/* eslint-disable no-unused-vars */
import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  gap: 24px;
  width: 70%;
`;
